<template>
  <div class="login-pass">
    <a-form
      ref="modalFormRef"
      :model="formState"
      @finish="handleFinish"
      @finishFailed="handleFinishFailed"
    >
      <a-form-item
        name="mobile"
        :rules="[
          { required: true, message: '请输入手机号!' },
          { pattern: /^1[3-9][0-9]\d{8}$/, message: '请输入正确的手机号' }
        ]"
      >
        <a-input v-model:value="formState.mobile" placeholder="请输入手机号" size="large" :len="11">
          <template #prefix>
            <UserOutlined style="color: rgba(0, 0, 0, 0.25)" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item
        class="code-form-item"
        name="code"
        :rules="[{ required: true, message: '请输入验证码!' }]"
      >
        <a-input v-model:value="formState.code" type="password" placeholder="请输入验证码" size="large">
          <template #prefix>
            <LockOutlined style="color: rgba(0, 0, 0, 0.25)" />
          </template>
        </a-input>
        <a-button
          size="large"
          :disabled="code.disabled"
          type="primary"
          class="code-btn"
          @click="sendCodeFn"
        >{{ code.text }}</a-button>
      </a-form-item>
      <a-form-item>
        <a-button
          size="large"
          class="save-btn"
          type="primary"
          html-type="submit"
          :disabled="formState.user === '' || formState.password === ''"
        >立即登录</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script setup>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { reactive, ref } from 'vue';
import { sendCode, loginCode } from '@/common/api';
import { setLocalStorage } from '@/common/storage';
const formState = reactive({
  mobile: '',
  code: '',
  checkCodeKeyId: ''
});
const code = reactive({
  second: 60,
  disabled: false,
  text: '发送短信验证码',
  timer: null
})
const modalFormRef = ref();
const sendCodeFn = () => {
  modalFormRef.value.validate(['mobile']).then(() => {
    code.disabled = true
    code.second--
    code.timer = setInterval(() => {
      if (code.second == 1) {
        clearInterval(code.timer)
        code.second = 60
        code.disabled = false
        code.text = `发送短信验证码`
      } else {
        code.disabled = true
        code.text = `${code.second}秒`
        code.second--
      }
    }, 1000)
    sendCode({
      data: {
        mobile: formState.mobile
      },
      success: res => {
        message.success('短信验证码发送成功');
        formState.checkCodeKeyId = res.checkCodeKeyId
      }
    })
  }).catch((err) => {
    console.log(err);
  });
}

const handleFinish = values => {
  loginCode({
    data: {
      ...values,
      checkCodeKeyId: formState.checkCodeKeyId
    },
    success: res => {
      setLocalStorage('accessToken', res.access_token, res.expires_in)
      window.location.href = location.origin + '/oadmin/'
    }
  })
};

const handleFinishFailed = errors => {
  console.log(errors);
};


</script>
<style lang="less">
.login-pass {
  padding-top: 20px;
  .code-form-item {
    .ant-form-item-control-input-content {
      display: flex;
    }
    .code-btn {
      margin-left: 12px;
      width:142px;
    }
  }
}
</style>